import { Injectable } from '@angular/core';
import { NotificationMessage } from '../model/notification-message.model';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationProviderService {

  constructor(private toastr: ToastrService) { }

  public notify(data: NotificationMessage): void {
    this.playSound();

    this.toastr.success(data.message, data.title);
  }

  private playSound(): void {
    const soundPath: string = 'assets/sounds/notify.wav';
    const audio = new Audio(soundPath);
    audio.oncanplaythrough = (event) => {
      var playedPromise = audio.play();
      if (playedPromise) {
        playedPromise.catch((e) => {
          console.log(e);
        }).then(() => {
          console.log("playing sound !!!");
        });
      }
    }
  }
}
